import React, { useState, useEffect, useContext } from 'react'
import { Navigate, useLocation } from 'react-router';
import { AuthContext } from '../AuthContext.jsx';

const ProtectedRoute = ({ children }) => {
  const { authToken, onLogout, onLogin } = useContext(AuthContext);
  const location = useLocation();

  if (!authToken) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
};


export default ProtectedRoute